module.exports = __webpack_public_path__ + "static/media/online-inventory.c2070535.gif";